import * as actionTypes from '../actions/types';
const initialState = {};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_SALESFORCE_PRODUCTS:
      return { ...action.products };

    default:
      return state;
  }
};
